import TransformationCard from "./TransformationCard";
import { transformationAreas } from "@/data/transformationAreas";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { useLandingPageContext } from "@/hooks/useLandingPageContext";

const TransformationAreas = () => {
  const { generateTestId, generateId } = useLandingPageContext();
  return (
    <section className="py-16 sm:py-20 md:py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-dark-bg-secondary to-transparent" />
      <div className="container mx-auto px-4 sm:px-6 md:px-8 relative">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-playfair font-bold mb-4 sm:mb-6 text-white">
            6 Áreas da Sua Vida Que Vão Se Transformar
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
            Descubra como o AuraCode impacta cada aspecto da sua existência
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {transformationAreas.map((area, index) => (
            <TransformationCard
              key={index}
              icon={area.icon}
              title={area.title}
              description={area.description}
              gradientFrom={area.gradientFrom}
              gradientTo={area.gradientTo}
              iconColor={area.iconColor}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Button 
            size="lg" 
            className="text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-6 bg-secondary hover:bg-secondary/90 text-black font-bold button-glow shadow-2xl group rounded-xl w-full sm:w-auto" 
            id={generateId('transformation', 'gerar-mapa')}
            data-testid={generateTestId('transformation', 'gerar-mapa')}
            onClick={() => {
              const element = document.getElementById('precos');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }}
          >
            <Sparkles className="mr-2 h-5 w-5 sm:h-6 sm:w-6 group-hover:animate-spin-slow transition-transform duration-500" />
            Gerar Meu Mapa Agora
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TransformationAreas;